export default __webpack_public_path__ + "static/media/trr-food-handheld-roastedchickenwrap.90235ddb.png";